import { render, staticRenderFns } from "./PropertyDivisionOrder.vue?vue&type=template&id=2ac5c02c"
import script from "./PropertyDivisionOrder.vue?vue&type=script&lang=ts"
export * from "./PropertyDivisionOrder.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports